import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { paths } from "../routes/paths";
import styles from "../styles/_components/fab.module.scss";

const FAB = () => {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  const actions = [
    { label: "קבע תור", path: paths.createAppointment, icon: "📅" },
    { label: "הוסף לקוח", path: `${paths.clients}?new=1`, icon: "👤" },
    { label: "שלח עדכון", path: paths.createNotifications, icon: "📢" },
  ];

  return (
    <div className={styles.fabContainer}>
      {/* Action menu */}
      {open && (
        <div className={styles.menu}>
          {actions.map((action) => (
            <button
              key={action.path}
              className={styles.menuItem}
              onClick={() => {
                navigate(action.path);
                setOpen(false);
              }}
            >
              <span className={styles.menuIcon}>{action.icon}</span>
              <span className={styles.menuLabel}>{action.label}</span>
            </button>
          ))}
        </div>
      )}

      {/* Main FAB */}
      <button
        className={`${styles.fab} ${open ? styles.fabOpen : ""}`}
        onClick={() => setOpen(!open)}
        title="פעולה מהירה"
      >
        <span className={styles.fabIcon}>+</span>
      </button>
    </div>
  );
};

export default FAB;
